import { gql } from '@moonpig/web-core-graphql'

export const RemoveFromMultiBuyListGQL = gql`
  mutation RemoveFromMultiBuyList($input: RemoveFromMultiBuyListInput!) {
    removeFromMultiBuyList(input: $input) {
      __typename
      ... on RemoveFromMultiBuyListSuccess {
        multiBuyList {
          id
          itemCount
          items {
            __typename
            ... on MultiBuyListPersonalisableItem {
              id
              variant {
                key
                productId
                sku
                productImages {
                  mainImage {
                    small {
                      jpgUrl
                    }
                  }
                }
              }
            }
          }
        }
        product {
          id
          multiBuyList {
            count
          }
        }
      }
      ... on RemoveFromMultiBuyListError {
        message
      }
    }
  }
`
